import React, { useState, useEffect, useRef } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'
import { buttonTap } from '../config/animations'

export default function FacebookLoginButton() {
  const { login } = useAuth()
  const navigate = useNavigate()
  const [isConnecting, setIsConnecting] = useState(false)
  const popupRef = useRef(null)
  const timerRef = useRef(null)

  useEffect(() => {
    const handleMessage = async (event) => {
      if (event.data.type === 'facebook-auth') {
        setIsConnecting(false)
        clearInterval(timerRef.current)
        if (event.data.status === 200) {
          await login(event.data)
          navigate('/')
        } else {
          console.error('Facebook authentication failed:', event.data.message)
        }
      }
    }

    window.addEventListener('message', handleMessage)
    return () => {
      window.removeEventListener('message', handleMessage)
      clearInterval(timerRef.current)
    }
  }, [login, navigate])

  const handleFacebookLogin = () => {
    const width = 600
    const height = 600
    const left = window.screen.width / 2 - width / 2
    const top = window.screen.height / 2 - height / 2

    popupRef.current = window.open(
      '/users/auth/facebook',
      'facebook-login',
      `width=${width},height=${height},left=${left},top=${top}`
    )

    setIsConnecting(true)

    // Monitor popup close
    timerRef.current = setInterval(() => {
      if (popupRef.current?.closed) {
        clearInterval(timerRef.current)
        setIsConnecting(false)
      }
    }, 500)
  }

  return (
    <motion.button
      onClick={handleFacebookLogin}
      type="button"
      disabled={isConnecting}
      whileTap={!isConnecting ? buttonTap : undefined}
      whileHover={!isConnecting ? { scale: 1.01 } : undefined}
      className="w-full inline-flex items-center justify-center gap-3
        min-h-[52px] px-5 rounded-lg
        bg-[#1877F2] text-white font-medium text-base
        hover:bg-[#166FE5] active:bg-[#1565D8]
        disabled:opacity-70 disabled:cursor-wait
        shadow-sm hover:shadow-md
        transition-all duration-150
        focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1877F2]"
    >
      {isConnecting ? (
        <>
          <svg className="animate-spin h-5 w-5 flex-shrink-0" viewBox="0 0 24 24" fill="none">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
          </svg>
          Connecting...
        </>
      ) : (
        <>
          <svg
            className="w-5 h-5 flex-shrink-0"
            fill="currentColor"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
              clipRule="evenodd"
            />
          </svg>
          Continue with Facebook
        </>
      )}
    </motion.button>
  )
}
